// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q_1UPgKVTb {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.Q_1UPgKVTb h4 {
  line-height: 3em;
}
.Q_1UPgKVTb .C4JLjFe35X {
  float: left;
  width: 100%;
}
.Q_1UPgKVTb .qnQVfqD4U6 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.Q_1UPgKVTb .qnQVfqD4U6:hover {
  cursor: pointer;
}
.Q_1UPgKVTb .qnQVfqD4U6:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.pQ9eKNkkWo .EP7vtDScR6:focus {
  outline: none;
}
.pQ9eKNkkWo .EP7vtDScR6.IqFgMVcmB9.lwf0Z6f7Gb {
  background: #375A88;
}
.pQ9eKNkkWo .EP7vtDScR6.IqFgMVcmB9.lwf0Z6f7Gb span {
  color: #fff;
}
.pQ9eKNkkWo .lwf0Z6f7Gb {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.pQ9eKNkkWo .lwf0Z6f7Gb:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.pQ9eKNkkWo input {
  height: 38px;
  min-width: 220px;
}
.qnQVfqD4U6.mhhl3JMKjA {
  background: #410102;
}
.qnQVfqD4U6.R2ED1AOTHQ {
  background: #911318;
}
.qnQVfqD4U6.Tl3nEuFj0f {
  background: #D8293B;
}
.qnQVfqD4U6.o3DA4dbjjc {
  background: #F2373C;
}
.qnQVfqD4U6.y0nZgJzDee {
  background: #FC4448;
}
.qnQVfqD4U6.anHAKB_03u {
  background: #ED535E;
}
.qnQVfqD4U6.DN1eNPaHu0 {
  background: #E34926;
}
.qnQVfqD4U6.dqYeHsCGow {
  background: #FC562B;
}
.qnQVfqD4U6.V9raE9XlN_ {
  background: #FC6722;
}
.qnQVfqD4U6.OSsZpYUB8M {
  background: #FD7F24;
}
.qnQVfqD4U6.PU4nxlPjIp {
  background: #FD8D26;
}
.qnQVfqD4U6.KWKaLzSBke {
  background: #EC9C3E;
}
.qnQVfqD4U6.jKigTBdrec {
  background: #0e673a;
}
.qnQVfqD4U6.QwtcoFSXOD {
  background: #208740;
}
.qnQVfqD4U6.Ckdn1vUwgX {
  background: #239718;
}
.qnQVfqD4U6.hmLE1boFst {
  background: #55A84D;
}
.qnQVfqD4U6.wmtbWtJ_Tn {
  background: #4BBE5A;
}
.qnQVfqD4U6.PNVAXJ20KX {
  background: #0CCA6A;
}
.qnQVfqD4U6.k2FQ6meVaS {
  background: #0A3C64;
}
.qnQVfqD4U6.S3C9Aw_gWW {
  background: #0d487a;
}
.qnQVfqD4U6.fyV_GuxgQp {
  background: #10538d;
}
.qnQVfqD4U6.w92RCNLjxp {
  background: #115A99;
}
.qnQVfqD4U6.cmatot9j4h {
  background: #3387E2;
}
.qnQVfqD4U6.WggQSCLAVh {
  background: #1BA9CF;
}
.qnQVfqD4U6.P0WRug3Yve {
  background: #d27c02;
}
.qnQVfqD4U6.Fno5gCzhGV {
  background: #fb9402;
}
.qnQVfqD4U6.QLSCJtbujK {
  background: #FD9B30;
}
.qnQVfqD4U6.plx5mGGX8r {
  background: #FDBE2D;
}
.qnQVfqD4U6.oeg9nkEc3_ {
  background: #FED831;
}
.qnQVfqD4U6.L2CUDZtoPk {
  background: #FFFD38;
}
.qnQVfqD4U6.pqNN6YGfzJ {
  background: #2D215C;
}
.qnQVfqD4U6.okQcqRxx1Z {
  background: #483C83;
}
.qnQVfqD4U6.jS5gfDQEuA {
  background: #58518d;
}
.qnQVfqD4U6.nMFl39QaJH {
  background: #7068A9;
}
.qnQVfqD4U6.vc1mAXk6ji {
  background: #7f78b2;
}
.qnQVfqD4U6.xsXJDXbb5a {
  background: #8f88bc;
}
.qnQVfqD4U6.u6aSUdnNa6 {
  background: #000;
}
.qnQVfqD4U6.EajoCImnq9 {
  background: #282626;
}
.qnQVfqD4U6.IPm7aRGj9g {
  background: #242222;
}
.qnQVfqD4U6.bQSH5heDF1 {
  background: #353838;
}
.qnQVfqD4U6.xZLZCOVTMp {
  background: #666;
}
.qnQVfqD4U6.AzcyS4QvoF {
  background: #999;
}
.LljR5CLiHt {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.LljR5CLiHt .XX5ZdwZQuU {
  display: none;
}
.sMDXlJzEnX {
  padding: 16px;
}
.sMDXlJzEnX .jrai2lYqLz {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}
.sMDXlJzEnX .jrai2lYqLz > label {
  text-transform: capitalize;
  font-size: 13px !important;
  margin-bottom: 0;
}
.sMDXlJzEnX .pkTeeJFh13 {
  display: flex;
  border: 1px solid #CAC9CC;
  border-radius: 4px;
  overflow: hidden;
  background: #F5F6FA;
  width: max-content;
}
.sMDXlJzEnX .pkTeeJFh13 .tAlZ3VYT0J {
  flex: 0 0 auto;
  min-width: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 500;
  color: black;
  margin: 0;
  height: 32px;
  transition: background 0.2s, color 0.2s;
  padding: 8px 16px;
}
.sMDXlJzEnX .pkTeeJFh13 .tAlZ3VYT0J .mJcMBdpsFg {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  font-size: 12px;
  letter-spacing: 0;
}
.sMDXlJzEnX .pkTeeJFh13 .tAlZ3VYT0J.IqFgMVcmB9 {
  background: var(--v3-indigo-50);
  color: var(--v3-indigo-700);
  border-color: var(--v3-indigo-200);
}
.sMDXlJzEnX .pkTeeJFh13 .tAlZ3VYT0J .kKwRBlf7k8 {
  display: flex;
  align-items: center;
}
.pkTeeJFh13 .tAlZ3VYT0J:not(:last-child) {
  border-right: 1px solid #CAC9CC;
}
.tAlZ3VYT0J {
  transition: all 0.2s ease;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `Q_1UPgKVTb`,
	"color-row": `C4JLjFe35X`,
	"color-tile": `qnQVfqD4U6`,
	"picker-component": `pQ9eKNkkWo`,
	"picker-element": `EP7vtDScR6`,
	"active": `IqFgMVcmB9`,
	"btn": `lwf0Z6f7Gb`,
	"red-1": `mhhl3JMKjA`,
	"red-2": `R2ED1AOTHQ`,
	"red-3": `Tl3nEuFj0f`,
	"red-4": `o3DA4dbjjc`,
	"red-5": `y0nZgJzDee`,
	"red-6": `anHAKB_03u`,
	"orange-1": `DN1eNPaHu0`,
	"orange-2": `dqYeHsCGow`,
	"orange-3": `V9raE9XlN_`,
	"orange-4": `OSsZpYUB8M`,
	"orange-5": `PU4nxlPjIp`,
	"orange-6": `KWKaLzSBke`,
	"green-1": `jKigTBdrec`,
	"green-2": `QwtcoFSXOD`,
	"green-3": `Ckdn1vUwgX`,
	"green-4": `hmLE1boFst`,
	"green-5": `wmtbWtJ_Tn`,
	"green-6": `PNVAXJ20KX`,
	"blue-1": `k2FQ6meVaS`,
	"blue-2": `S3C9Aw_gWW`,
	"blue-3": `fyV_GuxgQp`,
	"blue-4": `w92RCNLjxp`,
	"blue-5": `cmatot9j4h`,
	"blue-6": `WggQSCLAVh`,
	"yellow-1": `P0WRug3Yve`,
	"yellow-2": `Fno5gCzhGV`,
	"yellow-3": `QLSCJtbujK`,
	"yellow-4": `plx5mGGX8r`,
	"yellow-5": `oeg9nkEc3_`,
	"yellow-6": `L2CUDZtoPk`,
	"purple-1": `pqNN6YGfzJ`,
	"purple-2": `okQcqRxx1Z`,
	"purple-3": `jS5gfDQEuA`,
	"purple-4": `nMFl39QaJH`,
	"purple-5": `vc1mAXk6ji`,
	"purple-6": `xsXJDXbb5a`,
	"black-1": `u6aSUdnNa6`,
	"black-2": `EajoCImnq9`,
	"black-3": `IPm7aRGj9g`,
	"black-4": `bQSH5heDF1`,
	"black-5": `xZLZCOVTMp`,
	"black-6": `AzcyS4QvoF`,
	"picker-theme": `LljR5CLiHt`,
	"arrow-regular": `XX5ZdwZQuU`,
	"segmented-container": `sMDXlJzEnX`,
	"segmented-label": `jrai2lYqLz`,
	"segmented-buttons": `pkTeeJFh13`,
	"segmented-item": `tAlZ3VYT0J`,
	"label": `mJcMBdpsFg`,
	"icon": `kKwRBlf7k8`
};
export default ___CSS_LOADER_EXPORT___;
